<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view v-if="isRouterAlive"></router-view>
    </div>
  </a-config-provider>
</template>
<script>
  import enquireScreen from '@/utils/device'
  import { getAntdLocale } from '@/i18n'

  export default {
    data () {
      return {
        isRouterAlive: true// �����ǰҳ����ת��ǰҳ�������ݲ�ˢ������
      }
    },
    computed: {
      // i18n：Antd 根级 locale 随语言切换（覆盖登录页等 TabLayout 之外的路由）
      locale() {
        return getAntdLocale(this.$store.state.app.language)
      }
    },
    provide() {
      return{
        reload: this.reload
      }
    },
    methods: {
      reload() {
        this.isRouterAlive = false;
        this.$nextTick(()=> {
          this.isRouterAlive = true
        })
      }
    },
    created () {
      let that = this
      enquireScreen(deviceType => {
        // tablet
        if (deviceType === 0) {
          that.$store.commit('TOGGLE_DEVICE', 'mobile')
          that.$store.dispatch('setSidebar', false)
        }
        // mobile
        else if (deviceType === 1) {
          that.$store.commit('TOGGLE_DEVICE', 'mobile')
          that.$store.dispatch('setSidebar', false)
        }
        else {
          that.$store.commit('TOGGLE_DEVICE', 'desktop')
          that.$store.dispatch('setSidebar', true)
        }

      })
    }
  }
</script>
<style>
  #app {
    height: 100%;
  }
</style>